import React, { useState } from 'react'
import { Box, Icon, Typography } from '@mui/material'
import AdxInput from 'components/custom/AdxInput'
import { Link } from 'react-router-dom'
import AdxButton from 'components/custom/AdxButton'

const ACCustomEvaluationList = ({
  id,
  title,
  rightComponent,
  handleRemoveCustom,
  updateMutate,
  weightage,
}) => {
  const [selectValue, setSelectValue] = useState(weightage)

  const handleChange = (e) => {
    setSelectValue(e.target.value)
  }

  const handleUpdate = (e) => {
    updateMutate({ evaluationId: e.target.name, data: { weightage: +selectValue, title: title } })
  }
  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        columnGap={2}
        padding={2}
        sx={{
          borderBottom: '1px solid',
          borderBottomColor: 'gray-line.main',
        }}
      >
        <Typography variant="body1" color="dark-text.main" width="52%">
          {title}
        </Typography>
        <Box
          sx={{
            width: '20%',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Link
            to={`/app/management-centre/company-management/appraisal/evaluation/preview/${id}`}
            target="_blank"
            style={{
              textDecoration: 'none',
              color: 'white',
            }}
          >
            <AdxButton variant={'contained'} size="standard">
              Preview
            </AdxButton>
          </Link>
        </Box>
        <AdxInput
          value={selectValue}
          onChange={handleChange}
          onBlur={handleUpdate}
          type="number"
          placeholder="0"
          sx={{ width: '20%' }}
          name={id.toString()}
        />
        <Box display="flex" alignItems="center" justifyContent="space-between" width="8%">
          {rightComponent ? (
            rightComponent
          ) : (
            <>
              <Icon
                onClick={() => handleRemoveCustom(title, id)}
                sx={{
                  color: 'error.main',
                  cursor: 'pointer',
                }}
              >
                remove_circle
              </Icon>
            </>
          )}
        </Box>
      </Box>
    </>
  )
}

export default ACCustomEvaluationList
